/**
 * Satisfaction Guarantee JavaScript
 * Scrolls CLAIM NOW buttons to the product details section
 */

class SatisfactionGuarantee {
  constructor() {
    this.init();
  }

  init() {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        this.attachEventListeners()
      );
    } else {
      this.attachEventListeners();
    }
  }

  attachEventListeners() {
    const ctaButtons = document.querySelectorAll(".guarantee-section__cta");

    ctaButtons.forEach((button) => {
      button.addEventListener("click", this.scrollToProduct);
    });
  }

  scrollToProduct(event) {
    event.preventDefault();

    const productSection = document.querySelector(".shop-product-section");
    if (!productSection) return;

    window.scrollTo({
      top: window.scrollY + productSection.getBoundingClientRect().top - 80,
      behavior: "smooth",
    });
  }
}

new SatisfactionGuarantee();